<template>
    <div class="embed">
        <div class="d-flex input-box">
            <div class="form-group">
                <label>Width</label>
                <input type="text" class="form-control" :value="width" @change="changeEmbedSize('width', $event)" />
            </div>
            <div class="form-group">
                <label>Height</label>
                <input type="text" class="form-control" :value="height" @change="changeEmbedSize('height', $event)" />
            </div>
        </div>
        <textarea id="embed-input" class="form-control" :value="genEmbedURL()"></textarea>
        <button type="button" class="btn btn-secondary w-100 mt-3" @click="onCopy">Copy embed code</button>
    </div>
</template>

<script>
import appConfig from '../app.config.js'
export default {
    props: {
        quiz: {
            type: Object
        }
    },

    data() {
        return {
            embed: '',
            width: 1280, // default value
            height: 720 // default value
        }
    },

    methods: {
        selectText(containerid) {
            const id = document.querySelector(containerid)
            id.select()
        },

        onCopy() {
            let copyText = document.querySelector('#embed-input')
            copyText.select()
            copyText.setSelectionRange(0, 99999)
            navigator.clipboard.writeText(copyText.value)
            this.$emit('copied', copyText.value)
        },

        changeEmbedSize(type, e) {
            this[type] = e.target.value.replace(/[^0-9|%]+/g, '')
            this.embedSize = {
                width: this.width,
                height: this.height
            }
            localStorage.setItem('embed-size', JSON.stringify(this.embedSize))
        },

        setEmbedData(data) {
            this.embed = data
        },

        genEmbedURL() {
            const appBaseUrl = appConfig.apiBaseUrl.replace('/admin/api', '')
            return `<iframe width="${this.width}" height="${this.height}" src="${appBaseUrl}/embed/${this.embed.token_admin}" title="${this.quiz.title}" allow="clipboard-read; clipboard-write" frameborder="0" allowfullscreen></iframe>`
        }
    },

    mounted() {
        document.querySelector('#embed-input').addEventListener('click', () => {
            this.selectText('#embed-input')
        })

        if (localStorage.getItem('embed-size')) {
            this.embedSize = JSON.parse(localStorage.getItem('embed-size'))
            this.width = this.embedSize.width
            this.height = this.embedSize.height
        }
    }
}
</script>

<style lang="scss">
.embed {
    height: 100%;
    padding: 0 16px 16px 16px;
    border-bottom-left-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;

    .input-box {
        column-gap: 16px;

        div {
            flex: 1;
        }
    }

    textarea {
        min-height: 150px;
    }
}

.theme-dark-mode .embed {
    background-color: #383838;
}
</style>
